export const ImgURL = "https://admin.zayadryfruits.com/";
// export const ImgURL = "http://127.0.0.1:8000/";
// export const ImgURL = "http://192.168.1.23:8000/";


export const URL = "https://admin.zayadryfruits.com/api";
// export const URL = "http://192.168.1.23:8000/api";
// export const URL = "http://127.0.0.1:8000/api";
